const de = {
  farright: 'rechts aussen',
  rightpopulist: 'rechts aussen & populistisch',
  populists: 'übrige populistische Parteien',
  farleft: 'links aussen',
  leftpopulist: 'links aussen & populistisch',
  others: 'übrige gemässigte Parteien',
  seat: 'Sitz',
  seats: 'Sitze',
  sources: 'Quellen',
  research: 'eigene Recherche',
}
const fr = {
  farright: 'extrême droite',
  rightpopulist: 'extrême droite & populiste',
  populists: 'autres partis populistes',
  farleft: 'extrême gauche',
  leftpopulist: 'extrême gauche & populiste',
  others: 'autres partis modérés',
  seat: 'siège',
  seats: 'sièges',
  sources: 'Sources',
  research: 'propre recherche',
}
export { de, fr }
